import Typography from "@mui/material/Typography"
import { observer } from "mobx-react-lite"

export default observer(function GapDataGridHeaderTypography(props: { title: string }) {
   return <Typography color="text.primary" fontWeight={700}>{props.title}</Typography>
})
